import dynamic from 'next/dynamic'

const groupRegistry = {
  'group-wrapper-article': dynamic(() => import('./Wrapper/Article/WrapperArticle')),
  'group-grid-grid': dynamic(() => import('./Grid/Grid/GridGrid')),
  'group-grid-article': dynamic(() => import('./Grid/Article/GridArticle')),
  'group-grid-article-collection': dynamic(() => import('./Grid/ArticleCollection/GridArticleCollection')),
  'group-grid-content': dynamic(() => import('./Grid/Content/GridContent')),
  'group-grid-sidebar': dynamic(() => import('./Grid/Sidebar/GridSidebar')),
  'group-grid-wrapper': dynamic(() => import('./Grid/Wrapper/GridWrapper')),
  'group-wrapper-testing': dynamic(() => import('./Wrapper/Testing/WrapperTesting')),
}

export default groupRegistry
